import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["type", "value"]
const _hoisted_2 = {
  key: 0,
  class: "search_buttons_container"
}
const _hoisted_3 = {
  key: 1,
  class: "hint-container"
}
const _hoisted_4 = { class: "hint-content-email" }
const _hoisted_5 = {
  key: 3,
  class: "hint-container"
}
const _hoisted_6 = { class: "hint-content-email" }
const _hoisted_7 = {
  key: 4,
  class: "hint-container"
}
const _hoisted_8 = { class: "hint-content-email" }
const _hoisted_9 = {
  key: 5,
  class: "hint-container"
}
const _hoisted_10 = { class: "hint-content-email" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppIcon = _resolveComponent("AppIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-wrapper password-wrapper", { focused: $setup.isFocused || $setup.hasValue }]),
    onMouseenter: _cache[10] || (_cache[10] = ($event: any) => ($setup.showClearIconMouseHold = true)),
    onMouseleave: _cache[11] || (_cache[11] = ($event: any) => ($setup.showClearIconMouseHold = false))
  }, [
    _createElementVNode("input", {
      id: "password-input-elm",
      class: "style-input",
      type: $setup.fieldType,
      name: "password",
      autocomplete: "current-password",
      value: $props.modelValue,
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.handleInput && $setup.handleInput(...args))),
      onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.onFocus && $setup.onFocus(...args))),
      onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.onBlur && $setup.onBlur(...args))),
      onAnimationstart: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.handleAutofillStart && $setup.handleAutofillStart(...args))),
      ref: "inputRef",
      style: _normalizeStyle($setup.inputStyle)
    }, null, 44, _hoisted_1),
    _createElementVNode("label", {
      class: _normalizeClass(["floating-label", { active: $setup.isFocused || $setup.hasValue }])
    }, _toDisplayString(_ctx.$t("Login.Password")), 3),
    ($setup.showIcons)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          ($setup.showClearIcon)
            ? (_openBlock(), _createBlock(_component_AppIcon, {
                key: 0,
                name: "arrow-left",
                width: "16px",
                class: "pointer",
                onClick: $setup.clearField,
                color: "#D2D2D2",
                onMouseenter: _cache[4] || (_cache[4] = ($event: any) => ($setup.showClearHint = true)),
                onMouseleave: _cache[5] || (_cache[5] = ($event: any) => ($setup.showClearHint = false)),
                onMousedown: _withModifiers($setup.clearField, ["prevent"])
              }, null, 8, ["onClick", "onMousedown"]))
            : _createCommentVNode("", true),
          ($setup.showClearHint)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("Login.ClearField")), 1)
              ]))
            : _createCommentVNode("", true),
          ($props.error && !$setup.isFocused)
            ? (_openBlock(), _createBlock(_component_AppIcon, {
                key: 2,
                name: "invalid",
                width: "16px",
                class: "pointer",
                color: "#FF5533",
                onMouseenter: _cache[6] || (_cache[6] = ($event: any) => ($setup.showErrorHint = true)),
                onMouseleave: _cache[7] || (_cache[7] = ($event: any) => ($setup.showErrorHint = false))
              }))
            : _createCommentVNode("", true),
          ($setup.showErrorHint)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("Login.CheckPassword")), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_AppIcon, {
            name: $setup.visibilityIcon,
            width: "16px",
            class: "pointer",
            color: "#979797",
            onClick: $setup.toggleVisibility,
            onMouseenter: _cache[8] || (_cache[8] = ($event: any) => ($setup.showVisibilityHint = true)),
            onMouseleave: _cache[9] || (_cache[9] = ($event: any) => ($setup.showVisibilityHint = false))
          }, null, 8, ["name", "onClick"]),
          (!$setup.isVisible && $setup.showVisibilityHint)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("Login.ShowPassword")), 1)
              ]))
            : _createCommentVNode("", true),
          ($setup.isVisible && $setup.showVisibilityHint)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("Login.HidePassword")), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 34))
}